import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './app';
import '../css/index.css';
ReactDOM.render(React.createElement(App, null), document.getElementById('root'));
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./src/index.js